const headers = {
  'X-CSRF-Token': document.querySelector('meta[name=csrf-token]').getAttribute('content'),
}

export { headers }
